import React from "react"
const ReaderRewardSheet = React.lazy(() => import("./ReaderRewardSheet"))
const StoreB = React.lazy(() => import("./storeB"))
const StoreF = React.lazy(() => import("./storeF"))
const Store3 = React.lazy(() => import("components/ReaderFlowIos/store3"))
const AccountF = React.lazy(() => import("./accountF"))
const Account3 = React.lazy(() => import("components/ReaderFlowIos/account3"))

const ReaderV5Routes = [
  {
    path: "reader-reward-sheet",
    element: <ReaderRewardSheet />
  },
  ...["reader-storeb", "reader-accountb"].map(pathUrl => ({
    path: pathUrl,
    element: <StoreB />
  })),
  ...["reader-storec", "reader-stored", "reader-storee", "reader-storeg"].map(
    pathUrl => ({
      path: pathUrl,
      element: <Store3 />
    })
  ),
  ...[
    "reader-accountc",
    "reader-accountd",
    "reader-accounte",
    "reader-accountg"
  ].map(pathUrl => ({
    path: pathUrl,
    element: <Account3 />
  })),
  {
    path: "reader-accountf",
    element: <AccountF />
  },
  {
    path: "reader-storef",
    element: <StoreF />
  }
]

export { ReaderV5Routes }
